module.exports = __webpack_public_path__ + "img/favicon.c4dd4b00.png";